import {
  berachain,
  monad,
  plasma,
  sonic,
  swell,
  tac,
  tenderly,
} from "@eulerxyz/core-sdk"
import {
  arbitrumLabels,
  avalancheLabels,
  baseLabels,
  berachainLabels,
  bobLabels,
  bscLabels,
  lineaLabels,
  mainnetLabels,
  monadLabels,
  plasmaLabels,
  sonicLabels,
  swellLabels,
  tacLabels,
  unichainLabels,
} from "@eulerxyz/euler-labels"
import { Config } from "@wagmi/core"
import { ChainIdParameter } from "@wagmi/core/internal"
import { Evaluate } from "viem"
import {
  arbitrum,
  avalanche,
  base,
  bob,
  bsc,
  foundry,
  linea,
  mainnet,
  unichain,
} from "wagmi/chains"

export type GetLabelsParameters<config extends Config = Config> = Evaluate<
  ChainIdParameter<config>
>

export function getVaultLabels<config extends Config = Config>({
  chainId,
}: GetLabelsParameters<config>) {
  switch (chainId) {
    case mainnet.id:
    case foundry.id:
    case tenderly.id:
      return mainnetLabels.vaults
    case base.id:
      return baseLabels.vaults
    case swell.id:
      return swellLabels.vaults
    case sonic.id:
      return sonicLabels.vaults
    case bob.id:
      return bobLabels.vaults
    case berachain.id:
      return berachainLabels.vaults
    case avalanche.id:
      return avalancheLabels.vaults
    case bsc.id:
      return bscLabels.vaults
    case unichain.id:
      return unichainLabels.vaults
    case arbitrum.id:
      return arbitrumLabels.vaults
    case tac.id:
      return tacLabels.vaults
    case linea.id:
      return lineaLabels.vaults
    case plasma.id:
      return plasmaLabels.vaults
    case monad.id:
      return monadLabels.vaults
    default: {
      return undefined
    }
  }
}

export function getEntities<config extends Config = Config>({
  chainId,
}: GetLabelsParameters<config>) {
  switch (chainId) {
    case mainnet.id:
    case foundry.id:
    case tenderly.id:
      return mainnetLabels.entities
    case base.id:
      return baseLabels.entities
    case swell.id:
      return swellLabels.entities
    case sonic.id:
      return sonicLabels.entities
    case bob.id:
      return bobLabels.entities
    case berachain.id:
      return berachainLabels.entities
    case avalanche.id:
      return avalancheLabels.entities
    case bsc.id:
      return bscLabels.entities
    case unichain.id:
      return unichainLabels.entities
    case arbitrum.id:
      return arbitrumLabels.entities
    case tac.id:
      return tacLabels.entities
    case linea.id:
      return lineaLabels.entities
    case plasma.id:
      return plasmaLabels.entities
    case monad.id:
      return monadLabels.entities
    default: {
      return undefined
    }
  }
}

export function getPointsMarkets<config extends Config = Config>({
  chainId,
}: GetLabelsParameters<config>) {
  switch (chainId) {
    case mainnet.id:
    case foundry.id:
    case tenderly.id:
      return mainnetLabels.points
    case base.id:
      return baseLabels.points
    case swell.id:
      return swellLabels.points
    case sonic.id:
      return sonicLabels.points
    case bob.id:
      return bobLabels.points
    case berachain.id:
      return berachainLabels.points
    case avalanche.id:
      return avalancheLabels.points
    case bsc.id:
      return bscLabels.points
    case unichain.id:
      return unichainLabels.points
    case arbitrum.id:
      return arbitrumLabels.points
    case tac.id:
      return tacLabels.points
    case plasma.id:
      return plasmaLabels.points
    case linea.id:
      return lineaLabels.points
    case monad.id:
      return monadLabels.points
    default: {
      return undefined
    }
  }
}
